import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/internal/operators/catchError';
import { AppService } from '../app.service';
import { AlertService } from '../alert.service';
import { AlertInfo } from '../../enums/alert-info';
import { CommonService } from '../common.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  currentUser: any;

  // constructor() {}

  // intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
  //   return next.handle(request);
  // }
  constructor( private appService: AppService, 
    private authenticationService: AuthenticationService, 
    private router: Router, 
    private alertService:AlertService,
    private commonService: CommonService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    this.currentUser = this.appService.getToken();
    if (this.currentUser && this.currentUser.accessToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.currentUser.accessToken}`,
          'Cache-Control':
            'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
          Pragma: 'no-cache',
          Expires: '0',
        },
      });
    }

    return next.handle(request).pipe(catchError(err => {
      this.commonService.hide();
       const error = (err&&err.error)  ? (err?.statusText +' '+ err.error.message ) : (err?.statusText +' '+'error occured');
      this.alertService.showMessage(AlertInfo.ERROR, 'Error: An error has occurred. Please try again or contact support.');
      if (err.status !== 401) {
        return throwError(error);
      }
      this.authenticationService.logout();
      this.commonService.logOut(false);
      this.router.navigate(['/auth/login']);
      return throwError(error);
    }))
  }
}
